const common = {
  "nav.services": "Servicios",
  "nav.expertise": "Especialidades",
  "nav.about": "Sobre Mí",
  "nav.testimonials": "Testimonios",
  "nav.bookSession": "Reservar Sesión",
  "nav.toggleMenu": "Abrir menú",
  "lang.switchTo": "English",
  "lang.label": "EN",
  "footer.description": "Ayudo a profesionales de la cadena de suministro y jóvenes que inician su carrera a construir trayectorias profesionales exitosas y satisfactorias en Europa, mediante orientación experta y mentoría personalizada.",
  "footer.contact": "Contacto",
  "footer.quickLinks": "Enlaces Rápidos",
  "footer.services": "Servicios",
  "footer.expertise": "Áreas de Especialidad",
  "footer.about": "Sobre Mí",
  "footer.testimonials": "Testimonios",
  "footer.bookSession": "Reservar Sesión",
  "footer.privacy": "Política de Privacidad",
  "footer.terms": "Términos del Servicio",
  "footer.cookies": "Política de Cookies",
  "footer.copyright": "Mentored by Julen. Todos los derechos reservados.",
  "footer.address": "Bruselas, Bélgica",
  "footer.phone": "+31 6 1234 5678",
  "footer.email": "hola@mentoredbyjulen.eu",
};

export default common;